import React from 'react';
import { useTranslation } from 'react-i18next';
import './BusinessValue.css';

const BusinessValue = () => {
  const { t } = useTranslation();

  const values = [
    {
      metric: t('value1Metric'),
      title: t('value1Title'),
      description: t('value1Description'),
      accent: 'revenue',
    },
    {
      metric: t('value2Metric'),
      title: t('value2Title'),
      description: t('value2Description'),
      accent: 'management',
    },
    {
      metric: t('value3Metric'),
      title: t('value3Title'),
      description: t('value3Description'),
      accent: 'visibility',
    },
    {
      metric: t('value4Metric'),
      title: t('value4Title'),
      description: t('value4Description'),
      accent: 'retention',
    },
  ];

  return (
    <section id="benefits" className="business-value" aria-label={t('businessValueTitle')}>
      <div className="container">
        <div className="business-value-header">
          <p className="section-eyebrow">{t('benefits')}</p>
          <h2 className="section-title">{t('businessValueTitle')}</h2>
          <p className="section-subtitle">{t('businessValueDescription')}</p>
        </div>

        <div className="value-grid">
          {values.map((item) => (
            <article key={item.accent} className={`value-card value-card--${item.accent}`}>
              <div className="value-metric">{item.metric}</div>
              <h3 className="value-title">{item.title}</h3>
              <p className="value-description">{item.description}</p>
            </article>
          ))}
        </div>

        <div className="value-showcase">
          <div className="value-showcase-content">
            <h3 className="value-showcase-title">{t('valueShowcaseTitle')}</h3>
            <p className="value-showcase-text">{t('valueShowcaseText')}</p>
            <ul className="value-showcase-list">
              <li>{t('valueShowcaseItem1')}</li>
              <li>{t('valueShowcaseItem2')}</li>
              <li>{t('valueShowcaseItem3')}</li>
              <li>{t('valueShowcaseItem4')}</li>
            </ul>
          </div>
          <div className="value-showcase-visual" aria-hidden="true">
            <div className="dashboard-mock">
              <div className="dashboard-mock-header">
                <span className="dashboard-dot" />
                <span className="dashboard-dot" />
                <span className="dashboard-dot" />
              </div>
              <div className="dashboard-mock-body">
                <div className="dashboard-stat">
                  <span className="dashboard-stat-label">{t('dashBookings')}</span>
                  <span className="dashboard-stat-value">+34%</span>
                </div>
                <div className="dashboard-stat">
                  <span className="dashboard-stat-label">{t('dashRevenue')}</span>
                  <span className="dashboard-stat-value">↑</span>
                </div>
                <div className="dashboard-chart">
                  <div className="dashboard-bar" style={{ height: '45%' }} />
                  <div className="dashboard-bar" style={{ height: '70%' }} />
                  <div className="dashboard-bar" style={{ height: '55%' }} />
                  <div className="dashboard-bar" style={{ height: '85%' }} />
                  <div className="dashboard-bar" style={{ height: '65%' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessValue;
